import '../../styles/signup.css';
import { Logo } from '../../assets/Logo';
import { useNavigate } from 'react-router-dom';

interface SignupLeftLayoutProps {
  children: React.ReactNode;
}

export const SignupLeftLayout = ({ children }: SignupLeftLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="hidden lg:flex w-[60%] self-stretch flex-col justify-center items-center relative p-12 overflow-hidden mesh-gradient-premium">
      <div className="film-grain"></div>
      
      <button
        onClick={() => navigate('/login')}
        className="absolute top-10 left-10 z-20 opacity-90 hover:opacity-100 transition-opacity cursor-pointer bg-transparent border-none p-0"
      >
        <Logo />
      </button>

      {children}

      <div className="absolute bottom-12 left-12 max-w-sm z-20">
        <p className="text-[#101822]/40 text-lg font-medium leading-relaxed italic">
          "Tu clínica. Un solo lugar."
        </p>
      </div>
    </div>
  );
};
